import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import classnames from 'classnames'
import './styles.css'

export class Sidebar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      collapsed: true
    }
    this.toggleCollapsing = this.toggleCollapsing.bind(this)
  }

  toggleCollapsing() {
    this.setState({ collapsed: !this.state.collapsed })
  }

  render() {
    const { subscription, items, name, active, isMobile, height } = this.props
    const { collapsed } = this.state
    const subscribed = !_.isNull(subscription)
    const freeSubscription = subscribed && subscription.free
    const menuHeight = _.size(items) * 56

    return (
      <div
        id="Sidebar"
        style={{ minHeight: collapsed ? 65 : menuHeight + 45 }}
        className={classnames({ collapsed })}
      >
        {!isMobile && (
          <div className="sidebar-desktop">
            <div className="sidebar-holder">
              <div className="menu-header">
                <div>
                  <span>{name}</span>
                </div>
              </div>
              <ul className="menu-items">
                {items.map((item, itemIndex) => (
                  <li key={itemIndex}>
                    <Link to={item.url}>
                      <span className={classnames({ active: active === item.url })}>{item.name}</span>
                    </Link>
                  </li>
                ))}
              </ul>
              <div className="banner">
                <div className="subscription-status">
                  {!freeSubscription && (
                    <Link to="/change_subscription">
                      <span className={classnames({ active: active === '/change_subscription' })}>subscription</span>
                    </Link>
                  )}
                  {!freeSubscription && (
                    <span className={classnames({ accent: subscribed })}>
                      {subscribed ? subscription.plan : 'none'}
                    </span>
                  )}
                </div>
                {active !== '/change_subscription' && (
                  <>
                    {(!subscribed || subscription.rank < 3) && !freeSubscription && (
                      <Link to="/change_subscription">
                        <button type="button" className="subscribe-button btn -thin -orange">
                          {!subscribed ? 'Subscribe' : 'Upgrade'}
                        </button>
                      </Link>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        {isMobile && (
          <div className="topbar-mobile wrapper">
            <div
              className="current-element"
              onClick={() => this.toggleCollapsing()}
              onKeyDown={(e) => e.key === 'Enter' && this.toggleCollapsing()}
              role="button"
              tabIndex={0}
            >
              <span>{name}</span>
              <div className="arrow">
                <i className="icon-right-2" />
              </div>
            </div>
            <ul className="menu-items" style={{ maxHeight: collapsed ? 0 : height - 160 }}>
              {items.map((item, itemIndex) => (
                <li key={itemIndex}>
                  <Link to={item.url} onClick={() => this.toggleCollapsing()}>
                    <span className={classnames({ active: active === item.url || active === item.slug })}>
                      {item.name}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    )
  }
}

Sidebar.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      slug: PropTypes.string
    })
  ).isRequired,
  active: PropTypes.string.isRequired,
  subscription: PropTypes.shape({
    free: PropTypes.bool,
    rank: PropTypes.number,
    plan: PropTypes.string
  }),
  name: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  height: PropTypes.number
}

Sidebar.defaultProps = {
  subscription: null,
  isMobile: false,
  height: 0
}

export default Sidebar
